import { render, staticRenderFns } from "./CAROrderRemarkModal.vue?vue&type=template&id=ed2fd882&scoped=true"
import script from "./CAROrderRemarkModal.vue?vue&type=script&lang=ts"
export * from "./CAROrderRemarkModal.vue?vue&type=script&lang=ts"
import style0 from "./CAROrderRemarkModal.vue?vue&type=style&index=0&id=ed2fd882&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2fd882",
  null
  
)

export default component.exports